exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-area{display:inline-block;text-align:center}.price-area .error{color:#f44336;font-weight:lighter}", ""]);

// exports
